import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/qz_btn.png'
import _imports_1 from '../assets/img/bz_btn.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20220901/F934C57C-C334-92E5-7D56-E9ACD9F85E27.jpg",
  class: "banner",
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "qbz-btn" }, [
  /*#__PURE__*/_createVNode("a", { href: "https://h5.thepage.cn/apply/#/?id=6310943a0de0840049330051" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("a", { href: "https://h5.thepage.cn/apply/#/?id=63109666a901800043d4ada2" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("span", null, "@所有人")
], -1)
const _hoisted_6 = { class: "image-swiper" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "熊猫斩谣侠")
], -1)
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "抗疫故事")
], -1)
const _hoisted_11 = { class: "title" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "云求助")
], -1)
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "心情树洞")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Topic = _resolveComponent("Topic")
  const _component_ImageSwiper = _resolveComponent("ImageSwiper")
  const _component_News = _resolveComponent("News")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _withDirectives(_createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("a", {
        href: _ctx.topicLink(),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.topic.length]
    ]),
    _createVNode(_component_Topic, { data: _ctx.topic }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _createVNode(_component_ImageSwiper)
    ], 512), [
      [_vShow, _ctx.dt.length]
    ]),
    _withDirectives(_createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("a", {
        href: _ctx.cateLink(7398),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.py.length]
    ]),
    _createVNode(_component_News, { data: _ctx.py }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode("a", {
        href: _ctx.cateLink(7397),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.gs.length]
    ]),
    _createVNode(_component_News, { data: _ctx.gs }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode("a", {
        href: _ctx.cateLink(7405),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.qz.length]
    ]),
    _createVNode(_component_News, { data: _ctx.qz }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode("a", {
        href: _ctx.cateLink(7400),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.sd.length]
    ]),
    _createVNode(_component_News, { data: _ctx.sd }, null, 8, ["data"])
  ]))
}